import { useSuspenseQuery } from '@tanstack/react-query';
import { mainService } from '../api/mainService';
import { queryKey } from '../constant';

export const useMainTabs = () => {
  return useSuspenseQuery({
    queryKey: queryKey.mainTabs,
    queryFn: () => mainService.getMainTabs(),
  });
};
